import React, { useRef } from 'react';
import { motion } from 'motion/react';
import cn from 'classnames';

import { useScrollText } from '../../hooks/useScrollText';
import { iconsSources } from '../../helpers/icons';
import { clearTextFromTags, hideNumber } from '../../helpers/titreHelper';

import styles from './Message.module.css';

const Message = ({
  className,
  message,
  titrTag,
  setDelay,
  currentMessageRef,
  authorFontSize,
  msgFontSize,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const isCurrent = currentMessageRef?.message?.id === message?.id;

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    isCurrent,
  );

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <div className={cn(styles.wrapper, className)}>
      {message && (
        <div className={styles.msgBlock}>
          <div className={styles.avatar}>
            <motion.img
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5, delay: 0.7 + 0.12 }}
              exit={{ scale: 0 }}
              src={srcAvatar}
              alt=""
              onError={errorHandler}
            />
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5, delay: 0.7 }}
              exit={{ scale: 0 }}
              className={styles.avatarBorder}
            />
          </div>

          <motion.div
            initial={{ scale: 0, originX: 'left', originY: 'top' }}
            animate={{ scale: [0, 1.15, 1] }}
            transition={{
              duration: 0.72,
              delay: 0.82,
              times: [0, 0.9, 1],
              ease: ['ease-in', 'ease-out'],
            }}
            exit={{ scale: 0 }}
            className={styles.contentAndName}
          >
            <div
              style={{ fontSize: `${authorFontSize}rem` }}
              className={styles.name}
            >
              {message?.author || hideNumber(message?.senderNumber)}
            </div>

            <div className={styles.contentWrapper}>
              <div className={styles.content}>
                <div
                  className={styles.textWrapper}
                  ref={contentContainerRef}
                  style={{
                    maxHeight: `${4 * 1.4 * msgFontSize}rem`, // макс 4 строчек с высотой строки 140%
                  }}
                >
                  {message?.content && (
                    <div
                      className={styles.text}
                      ref={contentRef}
                      style={{
                        fontSize: `${msgFontSize}rem`,
                        lineHeight: `${1.4 * msgFontSize}rem`, // высота строки 140%
                      }}
                    >
                      {clearTextFromTags(message.content)}
                    </div>
                  )}
                </div>

                {/* {message?.attachments &&
                message?.attachments[0] &&
                message.attachments[0].type === 'image' && (
                  <div className={styles.contentImg}>
                    <img
                      src={message?.attachments[0].url}
                      alt={message?.author || hideNumber(message?.senderNumber)}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default React.memo(Message);
